import {types, getEnv} from 'mobx-state-tree';

export type WithFeedbackActions = {
  sendSuccessFeedback: (message?: string) => void;
  sendErrorFeedback: (message?: string) => void;
};

export default types.model().actions<WithFeedbackActions>(self => {
  const feedback = getEnv(self).appFeedback;

  return {
    sendSuccessFeedback: function(message?: string) {
      feedback.add({
        uid: `open${Date.now()}`,
        message: message || 'Great success!',
        intent: 'success'
      });
    },

    sendErrorFeedback: function(message?: string) {
      feedback.add({
        uid: `open${Date.now()}`,
        message: message || 'An error has occurred. Please try again later.',
        intent: 'error'
      });
    }
  };
});



// WEBPACK FOOTER //
// ./src/models/composables/withFeedbackModel.ts